function Event({ desc }) {
    return (
        <div>
            {desc}
        </div>
    );
}

export default Event;
